import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const CURRENCIES = ["USD", "EUR", "BRL", "GBP", "SAR"];
export const CURRENCY_SYMBOL = { USD: "$", EUR: "€", BRL: "R$", GBP: "£", SAR: "﷼" };
export const FX_TO_USD = { USD: 1.0, EUR: 1.08, BRL: 0.20, GBP: 1.27, SAR: 0.2667 };

export function fmtMoney(amount, currency = "USD") {
  const sym = CURRENCY_SYMBOL[currency] || "";
  const n = Number(amount || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  return `${sym}${n}`;
}

export function convert(amountUsd, target) {
  const rate = FX_TO_USD[target] || 1;
  return amountUsd / rate;
}
